import classNames from 'classnames'
import React from 'react'
import { Tooltip } from 'react-tooltip'

type Props = Omit<React.HTMLAttributes<HTMLDivElement>, 'id'> & {
  id: string
  tooltip: React.ReactNode
}

const PersistentOverlayTrigger: React.FC<Props> = ({
  tooltip,
  id,
  className,
  ...props
}) => (
  <>
    <div
      {...props}
      className={classNames('d-inline-block', className)}
      id={id}
    />

    <Tooltip
      anchorSelect={`#${id}`}
      clickable
      positionStrategy="fixed"
      place="top"
      className="p-2"
      delayHide={150}
    >
      {tooltip}
    </Tooltip>
  </>
)

export default PersistentOverlayTrigger
